import * as React from 'react';
import styled from 'styled-components';
import { Card, CardContent, CardTitle, Input, ChipsInput } from '../../../Components';
import { MonografiaModel, ValidationError } from '../../../Store';
import { format } from 'date-fns';
import { observer } from 'mobx-react';

interface IProps {
  monografia: MonografiaModel;
  onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChipsAddElement: (element: string) => void
  onChipsRemoveElement: (element: string) => void
  salvarAlteracoes: () => void
  validation: ValidationError<MonografiaModel>
}

const MonografiaContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12,1fr);
  grid-row-gap: 1rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;

const StyledInput = styled(Input) <any>`
  margin: 0;
  grid-column: ${p => p.gridColumn}
`;

const StyledChipsInput = styled(ChipsInput) <any>`
  margin: 0;
  grid-column: ${p => p.gridColumn};
`;



@observer
export class AlunoTccCard extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  render() {
    const {
      onTextChange,
      monografia,
      onChipsAddElement,
      onChipsRemoveElement,
      validation

    } = this.props;

    return (
      <Card>
        <CardTitle>TCC</CardTitle>
        <CardContent>
          <MonografiaContainer>
            <StyledInput
              label='Título'
              value={monografia.titulo}
              onChange={onTextChange}
              gridColumn='1/13'
            />
            {monografia.deposito &&
              monografia.deposito.dataDoDeposito &&
              <StyledInput
                label='Data do Depósito'
                disabled={true}
                value={format(monografia.deposito.dataDoDeposito, 'DD/MM/YYYY')}
                gridColumn='1/13'
              />
            }
            {monografia.nota ? (
              <StyledInput
                label='Nota Monografia'
                disabled={true}
                value={monografia.nota}
              />
            ) : (
              <StyledInput
              label='Nota Monografia'
              disabled={true}
              value='N/D'
            />)}
			      {monografia.notaOrientador ? (
              <StyledInput
                label='Nota Orientador'
                disabled={true}
                value={monografia.notaOrientador}
              />
            ) : (
              <StyledInput
              label='Nota Orientador'
              disabled={true}
              value='N/D'
            />)}
            {monografia.notaConvidado ? (
              <StyledInput
                label='Nota Convidado'
                disabled={true}
                value={monografia.notaConvidado}
              />
            ) : (
              <StyledInput
              label='Nota Convidado'
              disabled={true}
              value='N/D'
            />)}
            <StyledChipsInput
              values={monografia.palavrasChave.map(pc => pc.palavraChave)}
              gridColumn='1/13'
              label='Palavras-chave'
              onAddElement={onChipsAddElement}
              onDeleteElement={onChipsRemoveElement}
              maxLength={255}
              hasError={validation && !Array.isArray(validation.palavrasChave) && validation.palavrasChave}
              errorMessage={validation && !Array.isArray(validation.palavrasChave) && validation.palavrasChave || ''}
            />
          </MonografiaContainer>
        </CardContent>
      </Card>
    );
  }
}

